/* eslint-disable react/forbid-prop-types */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { BsArrowLeft } from 'react-icons/bs';
import PropTypes from 'prop-types';
import AppButton from '../app-button/AppButton';
import { isMobileWidth } from '../../helper-utils/appUtils';

function AppSidebar({
  sidebarTitle,
  children,
  onHideSidebar,
  className,
  animatedClass,
  modalClassName,
  showFooter,
  footerBtnText,
  onFooterClick,
}) {
  return (
    <Modal
      backdrop="static"
      keyboard={false}
      show
      fullscreen
      onHide={onHideSidebar}
      dialogClassName={animatedClass}
      className={`app-sidebar ${modalClassName}`}
    >
      {isMobileWidth() ? (
        <div className="app-sidebar__mobile-title modify-search-container p-2">
          <div className="d-flex align-items-center gap-2 px-2">
            <BsArrowLeft onClick={onHideSidebar} className="white-color" />
            <div className="flex-1 white-color">{sidebarTitle}</div>
          </div>
        </div>
      ) : (
        <Modal.Header closeButton>
          <Modal.Title className="app-sidebar__title">
            {sidebarTitle}
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className={className}>{children}</Modal.Body>
      {showFooter && (
        <Modal.Footer>
          <AppButton
            btnText={footerBtnText}
            variant="outlined"
            onClick={onFooterClick}
          />
        </Modal.Footer>
      )}
    </Modal>
  );
}

AppSidebar.defaultProps = {
  className: undefined,
  animatedClass: 'slide-from-right-animation',
  modalClassName: '',
  showFooter: false,
  footerBtnText: '',
  onFooterClick: () => {},
};

AppSidebar.propTypes = {
  sidebarTitle: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
  onHideSidebar: PropTypes.func.isRequired,
  className: PropTypes.string,
  animatedClass: PropTypes.string,
  modalClassName: PropTypes.string,
  showFooter: PropTypes.bool,
  footerBtnText: PropTypes.string,
  onFooterClick: PropTypes.func,
};

export default AppSidebar;
